// extracted by mini-css-extract-plugin
module.exports = {"container":"style_container__3tNgn","title":"style_title__1eoPa","subtitle":"style_subtitle__3gxF7"};